<template>
  <mdb-container fluid class="home">
    <RegisterLogin
      v-if="loginVisible"
      v-on:signup-requested="signupRequested"
      v-on:login-successful="loginSuccessful"
    />
  </mdb-container>
</template>

<script>
// @ is an alias to /src
import RegisterLogin from "@/components/RegisterLogin.vue";
import { mdbContainer } from "mdbvue";

export default {
  name: "DashBoardv1",
  components: {
    RegisterLogin,
    mdbContainer,
  },
  methods: {
    signupRequested() {
      this.loginVisible = false;
      this.signupVisible = true;
    },
    signupSuccessful() {
      this.signupVisible = false;
    },
    loginRequested() {
      this.loginVisible = true;
      this.signupVisible = false;
    },
    loginSuccessful() {
      this.loginVisible = false;
      this.loginReady = true;
    },
  },
  data: () => ({
    signupVisible: false,
    loginVisible: false,
    loginReady: false,
    isError: false,
    basicstatistics: [],
    sessioncheckpath: "/1.0/front/securesession/checkuser",
  }),
  mounted() {
    this.postdata = {
      token: this.$store.getters.getToken,
      name: this.$store.getters.getName,
    };
    this.$http
      .post(this.sessioncheckpath, this.postdata)
      .then((response) => {
        if (response.status == 200) {
          this.loginVisible = false;
          this.loginReady = true;
        } else {
          this.loginVisible = true;
        }
      })
      .catch((error) => {
        this.loginVisible = true;
        return error;
      })
      .finally();
  },
};
</script>

<style></style>
